module.exports = __webpack_public_path__ + "static/media/pen-square-light.6c3243b3.svg";